import styled from 'styled-components';

export const StyledAuthHeader = styled.div`
  display: flex;
  height: 45px;
  padding-left: 20px;
  justify-content: flex-start;
  align-content: center;
  align-items: center;
  border-bottom: 1px solid #dbdbdb;
  color: #8f8f8f;

  img {
    height: 22px;
  }

  span {
    margin-left: 10px;
    font-weight: 400;
  }
`;
